import { createAction } from 'redux-actions';

import { CLOSE_PRELOADER, OPEN_PRELOADER } from '../types';

export const openPreloaderAction = createAction(OPEN_PRELOADER);

export const closePreloaderAction = createAction(CLOSE_PRELOADER);
